import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("keybenefits");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Medical Device Security</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Medical Device Security</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  In the healthcare industry, medical devices are no longer
                  standalone tools—they are smart, connected, and critical to
                  patient safety. But with connectivity comes risk. Medical
                  devices are prime targets for cyberattacks, which can
                  compromise sensitive patient data, disrupt hospital
                  operations, and even impact patient care.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Patient Safety First",
                    desc: "Protect devices that directly impact patient health.",
                  },
                  {
                    icon: "fa-database",
                    title: "Data Protection",
                    desc: "Ensure sensitive patient information remains confidential and compliant.",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Regulatory Compliance",
                    desc: "Meet FDA, HIPAA, ISO 13485, and other global medical security standards.",
                  },
                  {
                    icon: "fa-table",
                    title: "Operational Continuity",
                    desc: "Prevent disruptions in hospitals, clinics, and healthcare systems.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Trust & Reputation",
                    desc: "Build confidence with patients, regulators, and healthcare partners.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Protect patients and healthcare operations from cyber threats.</li>
                        <li>Reduce risks of device tampering, ransomware, and data breaches.</li>
                        <li>Achieve compliance with healthcare regulations.</li>
                        <li>Build a resilient, secure medical device ecosystem.</li>
                        <li>Gain trust with patients, regulators, and healthcare providers.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li><b>Medical Device Risk Assessment Report</b></li>
                        <li><b>Vulnerability Analysis & Remediation Plan</b></li>
                        <li><b>Secure Configuration & Encryption Guidelines</b></li>
                        <li><b>Compliance Mapping (FDA, HIPAA, ISO, GDPR)</b></li>
                        <li><b>Continuous Monitoring & Incident Response Support</b></li>
                        <li><b>Executive Summary for Regulators & Healthcare Partners</b></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <ul>
                    <li><b>Device Risk Assessment :-</b> Identify vulnerabilities in IoMT (Internet of Medical Things) devices.</li>
                    <li><b>Secure Architecture :-</b> Implement strong access controls, encryption, and secure communications.</li>
                    <li><b>Threat Monitoring :-</b> Real-time detection and alerts to prevent unauthorized access or tampering.</li>
                    <li><b>Patch & Update Management :-</b> Ensure devices remain secure against new vulnerabilities.</li>
                    <li><b>Compliance Support :-</b> Align your devices with FDA, HIPAA, GDPR, and ISO requirements.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
